<script lang="ts">
export default {
  name: 'AccountProgramContact',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';
import { Mail } from '@lucide/vue';
import { AccountContact, ProgramContact } from '@/types/AccountContact';

interface GroupedAccountContacts {
  serviceTitle: string;
  contacts: AccountContact[];
}

const props = defineProps<{
  programContact: ProgramContact;
  expand: boolean;
}>();

const groupedContacts = computed(() => {
  // TODO: the program contacts transform logic will need to be reworked and simplified.
  // this complicated mess of a solution is to address the usage of the serviceTitle property to group the contacts.
  // The roles array actually contains the role associated with the array of contacts. This is most likely a side effect
  // from repurposing an interface which doesn't represent the structure of the expected incoming data.
  const contacts = props.programContact.contacts.map((c) => ({ ...c, contacts: c.contacts.map((cc) => ({ ...cc, serviceTitle: c.roles[0] })) }));

  const allContacts = contacts.flatMap((row) => row.contacts);

  const grouped = allContacts.reduce((acc, c) => {
    if (!acc.has(c.serviceTitle)) acc.set(c.serviceTitle, []);
    acc.get(c.serviceTitle)?.push(c);
    return acc;
  }, new Map<string, AccountContact[]>());

  const orderedContacts: GroupedAccountContacts[] = [];
  for (const [serviceTitle, contacts] of grouped) {
    orderedContacts.push({ serviceTitle, contacts } as GroupedAccountContacts);
  }

  return orderedContacts;
});
</script>

<template>
  <div class="flex w-full">
    <div>
      <div
        v-for="group in groupedContacts"
        :key="group.serviceTitle"
        class="contact-tuple mb-2">
        <div class="text-xs font-bold text-gray-500 uppercase">{{ group.serviceTitle }}:</div>
        <div
          v-for="contact in group.contacts"
          :key="contact.email">
          <span class="contact pr-5 wrap-break-word">
            <a
              :href="`mailto:${contact.email}`"
              class="pl-1 wrap-break-word">
              <mail
                class="inline h-4 w-4 transform text-gray-400 transition-all duration-200 hover:scale-110 hover:text-red-500" />
            </a>
            {{ contact.name }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
